var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserVerificationMultiChannelauthentication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multi-channel_authentication",
    "data-name": "Multi-channel authentication",
    transform: "translate(-14121 -10866)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_581",
    "data-name": "Ellipse 581",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(14121 10866)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(14160.843 10905.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph-2",
    "data-name": "Glyph",
    transform: "translate(0.15 0.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19358",
    "data-name": "Path 19358",
    d: "M136.343,48.054a1.656,1.656,0,0,0-1.226,1.988,68.373,68.373,0,0,1,1.822,15.636,67.274,67.274,0,0,1-67.194,67.194,66.406,66.406,0,0,1-40.5-13.6A11.118,11.118,0,1,0,27,121.719a69.678,69.678,0,0,0,42.746,14.466,70.583,70.583,0,0,0,68.6-86.894,1.656,1.656,0,0,0-2-1.237Z",
    transform: "translate(0.761 4.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19359",
    "data-name": "Path 19359",
    d: "M3.463,70.667A67.2,67.2,0,0,1,105.849,13.422a9.9,9.9,0,1,0,1.888-2.728A70.528,70.528,0,0,0,1.321,83.5a1.644,1.644,0,0,0,1.623,1.358,1.37,1.37,0,0,0,.3-.033A1.656,1.656,0,0,0,4.578,82.9,67.24,67.24,0,0,1,3.463,70.667Z",
    transform: "translate(-0.15 -0.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19360",
    "data-name": "Path 19360",
    d: "M55,55.051v.994H74.877v-.994C74.722,41.623,55.155,41.623,55,55.051Z",
    transform: "translate(5.568 4.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19361",
    "data-name": "Path 19361",
    d: "M115.174,34.467c-18.64.188-36.573-11.33-43.43-16.3a4.94,4.94,0,0,0-5.786,0c-6.857,4.969-24.835,16.442-43.43,16.3a5.008,5.008,0,0,0-5.057,4.991c.011,25.5,5.113,61.971,49.139,84.255a4.936,4.936,0,0,0,4.483,0c44.027-22.284,49.128-58.757,49.139-84.255a5.029,5.029,0,0,0-5.057-4.991Zm-28.1,50.42a8.282,8.282,0,0,1-8.282,8.282H58.913a8.282,8.282,0,0,1-8.282-8.282V67.219A8.282,8.282,0,0,1,55.6,59.633V57.922c.2-17.723,26.3-17.723,26.5,0v1.712a8.282,8.282,0,0,1,4.969,7.586Z",
    transform: "translate(1.656 1.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19362",
    "data-name": "Path 19362",
    d: "M67.115,69.386a1.069,1.069,0,0,1,.221-.844,3.565,3.565,0,1,0-5.864,0,1.058,1.058,0,0,1,.221.836c-.259,1.293-.994,4.99-1.512,7.556a2.208,2.208,0,0,0,2.168,2.635h4.108a2.208,2.208,0,0,0,2.167-2.641Z",
    transform: "translate(6.104 6.386)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVerificationMultiChannelauthentication);
export default __webpack_public_path__ + "static/media/User-Verification-Multi-channel authentication.51fec81566e2ba8818bd71be01ffdd14.svg";
export { ForwardRef as ReactComponent };